/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
import { Button } from "@/components/ui/button"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { makeRequest } from "@/utils/axiosInterceptor";
import { useState } from "react";

export default function ResetPasswordModal({resetPasswordDialog, setResetPasswordDialog, id}) {

    const [newPassword, setNewPassword] = useState("");
    const [myPassword, setMyPassword] = useState("");

    const resetPassword = async () => {
        try {
            const res = await makeRequest("POST",`/users/resetPassword/${id}`, {
                newPassword,
                myPassword
            });
            console.log(res);   
            if(res.status === 201) {
                alert("Password reset successfully");
                setResetPasswordDialog(false);
            }
        } catch (error) {
            console.log(error);
        }
       
    }
  return (
        <Dialog open={resetPasswordDialog} onOpenChange={(open) => setResetPasswordDialog(open)}>

          <DialogContent className="sm:max-w-[425px]">
            <DialogHeader>
              <DialogTitle>Reset User Password</DialogTitle>
              <DialogDescription>
                You can reset the user password. Please ensure if this is what you want to do. THIS CHANGE CANNOT BE UNDONE.
              </DialogDescription>
            </DialogHeader>
            <div className="grid gap-4 py-4">
              <div className="grid grid-cols-4 items-center gap-4">
                <Label htmlFor="new-password" className="text-right">
                  New Password
                </Label>
                <Input
                    value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  id="new-password"
                  placeholder= "New User Password"
                  className="col-span-3"
                  type="password"
                />
              </div>
              {/* <div className="grid grid-cols-4 items-center gap-4">
                <Label htmlFor="my-password" className="text-right">
                  My Password
                </Label>
                <Input
                    value={myPassword}
                    onChange={(e) => setMyPassword(e.target.value)}
                  id="my-password"
                  placeholder="My Password"
                  className="col-span-3"
                  type="password"
                />
              </div> */}
            </div>
            <DialogFooter>
              <Button onClick={resetPassword} type="submit">Save changes</Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>
  )
}
